import { FormControl, FormLabel, Input, type InputProps } from '@mui/joy';

export type FormMessage = { name?: string; message: string };

interface InputFieldProps extends InputProps {
  label?: string;
  innerRef?: React.Ref<HTMLInputElement>;
  errors?: FormMessage[];
  warnings?: FormMessage[];
  width?: string;
}
/** @deprecated Use `Input` from `shadcn/ui` instead */
export const InputField = (props: InputFieldProps) => (
  <FormControl size={props.size || 'sm'} sx={{ width: props.width }}>
    {props.label && (
      <FormLabel required={props.required}>{props.label}</FormLabel>
    )}
    <Input
      autoComplete="off"
      error={!!props.errors?.length || props.error}
      ref={props.innerRef}
      type="text"
      variant="outlined"
      {...props}
    />
    {!!props.errors?.length && (
      <ul className="w-full text-wrap pt-2 pl-3 text-red-700 text-xs">
        {props.errors.map(error => (
          <li className="list-disc" key={error.name}>
            {error.message}
          </li>
        ))}
      </ul>
    )}
    {!!props.warnings?.length && (
      <ul className="list-item w-full text-wrap pt-2 text-xs text-yellow-700">
        {props.warnings.map(warning => (
          <li key={warning.name}>{warning.message}</li>
        ))}
      </ul>
    )}
  </FormControl>
);
